import React from 'react';
import { ScissorsIcon, CalendarIcon, ArrowRightIcon } from 'lucide-react';
interface CouponBannerProps {
  onRedeem: () => void;
}
export const CouponBanner: React.FC<CouponBannerProps> = ({
  onRedeem
}) => {
  return <div className="py-8 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-92">
      <div onClick={onRedeem} className="max-w-4xl mx-auto bg-white border-2 border-dashed border-blue-500 rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer" data-id="element-93">
        <div className="relative" data-id="element-94">
          {/* Scissors icon in top left */}
          <div className="absolute -top-2 -left-2 bg-blue-600 rounded-full p-2 shadow-md" data-id="element-95">
            <ScissorsIcon className="h-4 w-4 text-white" data-id="element-96" />
          </div>
          {/* Scissors icon in top right */}
          <div className="absolute -top-2 -right-2 bg-blue-600 rounded-full p-2 shadow-md" data-id="element-97">
            <ScissorsIcon className="h-4 w-4 text-white" data-id="element-98" />
          </div>
          <div className="flex flex-col md:flex-row" data-id="element-99">
            {/* Left side - Offer */}
            <div className="md:w-3/5 p-6 md:p-8 bg-gradient-to-r from-blue-600 to-blue-700 text-white" data-id="element-100">
              <div className="mb-2 text-yellow-300 font-bold uppercase text-sm tracking-wider" data-id="element-101">
                Limited Time Offer
              </div>
              <h3 className="text-3xl md:text-4xl font-extrabold mb-3" data-id="element-102">
                50% OFF
              </h3>
              <h4 className="text-xl md:text-2xl font-bold mb-4" data-id="element-103">
                Tune-Ups & Preventive Maintenance
              </h4>
              <div className="flex items-center text-blue-100 mb-4" data-id="element-104">
                <CalendarIcon className="h-5 w-5 mr-2" data-id="element-105" />
                <span data-id="element-106">Offer valid until January 15th, 2026</span>
              </div>
              <p className="text-blue-100" data-id="element-107">
                Keep your system running efficiently and prevent costly
                breakdowns with our professional maintenance service.
              </p>
            </div>
            {/* Right side - Call to action */}
            <div className="md:w-2/5 p-6 md:p-8 flex flex-col justify-center items-center bg-white text-center" data-id="element-108">
              <p className="text-gray-600 mb-4" data-id="element-109">
                Schedule your discounted maintenance today and save!
              </p>
              <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-bold flex items-center justify-center transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" onClick={onRedeem} data-id="element-110">
                Redeem Now
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-111" />
              </button>
              <div className="mt-3 text-sm text-gray-500" data-id="element-112">
                *Cannot be combined with other offers
              </div>
            </div>
          </div>
          {/* Scissors icon in bottom left */}
          <div className="absolute -bottom-2 -left-2 bg-blue-600 rounded-full p-2 shadow-md" data-id="element-113">
            <ScissorsIcon className="h-4 w-4 text-white" data-id="element-114" />
          </div>
          {/* Scissors icon in bottom right */}
          <div className="absolute -bottom-2 -right-2 bg-blue-600 rounded-full p-2 shadow-md" data-id="element-115">
            <ScissorsIcon className="h-4 w-4 text-white" data-id="element-116" />
          </div>
        </div>
      </div>
    </div>;
};